import { ACTIVITY_HIERARCHY_MAP, DEFAULT_ACTIVITY_HIERARCHY } from '@constants'
import { VIPBuyingSessionProduct } from '@services/wholesale/productService'
import { stores, strings } from '@stores'
import { capitalize } from 'lodash'
import { action, computed, observable, ObservableMap, transaction } from 'mobx'
import { wholesaleCollectionService } from '@services/wholesale/wholesaleCollectionService'
export class BBProductSelectionStore {
  @observable bulkActionSelectedProducts = new ObservableMap()
  MAX_SELECTION_LIMIT = Infinity
  @observable allProductsData: {
    [key: string]: VIPBuyingSessionProduct
  } = {}
  @observable allProductsHierarchy: any = [] // Needed if we want to maintain track of previous selections
  @observable filteredProductsHierarchy: any = []
  @observable openClearSelelctionWarningDilaog = false
  @observable clearSelectionCallBack = null
  @computed get countOfBulkActionSelectedProducts() {
    return this.bulkActionSelectedProducts.size
  }

  @computed
  get bulkActionSelectedProductsList() {
    return Array.from(this.bulkActionSelectedProducts.keys())
  }

  setClearSelectionCallBack = (callback: Function | null) => {
    this.clearSelectionCallBack = callback
  }

  @action toggleOpenClearSelelctionWarningDilaog = () => {
    this.openClearSelelctionWarningDilaog = !this.openClearSelelctionWarningDilaog
  }

  isProductSelected = productId => {
    return this.bulkActionSelectedProducts.has(productId)
  }

  @action
  addToBulkActionSelectedProducts = (productId: string, value?) => {
    if (
      !productId ||
      this.bulkActionSelectedProducts.has(productId) ||
      this.countOfBulkActionSelectedProducts >= this.MAX_SELECTION_LIMIT
    ) {
      return
    }
    this.bulkActionSelectedProducts.set(
      productId,
      this.allProductsData[productId]?.hierarchyItems || {} // This will tell about the parent hierachy/group of that particular product
    )
  }

  @action
  removeFromBulkActionSelectedProducts = (productId: string) => {
    if (productId) {
      this.bulkActionSelectedProducts.delete(productId)
    }
  }

  @action
  resetBulkActionSelectedProducts = () => {
    this.bulkActionSelectedProducts.clear()
  }

  @computed get isEnhancedProductSelectionActive() {
    const {
      nav: {
        queryParams: { view, productLayout, assortmentType }
      }
    } = stores
    return !!(view === 'collection' && productLayout === strings.grid && !assortmentType)
  }

  getActiveProductsCount = productsHierarchy => {
    const temp = productsHierarchy?.reduce((acc, currItem) => {
      return acc + currItem?.activeProducts?.length || 0
    }, 0)
    return temp
  }

  @computed get countOfActiveProducts() {
    return this.getActiveProductsCount(this.filteredProductsHierarchy)
  }

  @action
  setAllProductsList = products => {
    const temp = {}
    if (this.isEnhancedProductSelectionActive) {
      products?.forEach(product => {
        const activity = product?.Original?.Activity?.Name || ''
        const hierarchy = [
          ...(ACTIVITY_HIERARCHY_MAP[activity] || DEFAULT_ACTIVITY_HIERARCHY)
        ]
        if (activity) {
          hierarchy.unshift('activity')
        }
        const hierarchyValues = hierarchy?.map(el => {
          return product?.Original?.[`${capitalize(el)}`]?.Name || ''
        })
        temp[product.Id] = {
          ...product,
          hierarchyItems: {
            hierarchy,
            hierarchyValues
          } // This field can be used to update grouping data status
        }
      })
    }
    this.allProductsData = temp
  }

  @action
  generateAllProductsHierarchy = (products: Array<any>) => {
    let hierarchy = []
    if (this.isEnhancedProductSelectionActive) {
      hierarchy = wholesaleCollectionService.buildOnlyProductsHierarchy(products)
    }
    this.allProductsHierarchy = hierarchy
  }

  @action
  generateFilteredProductsHierarchy = (products: Array<any>) => {
    let hierarchy = []
    if (this.isEnhancedProductSelectionActive) {
      hierarchy = wholesaleCollectionService.buildOnlyProductsHierarchy(products)
    }
    this.filteredProductsHierarchy = hierarchy
  }

  @action
  selectMultipleProducts = products => {
    products?.forEach(productId => {
      this.addToBulkActionSelectedProducts(productId)
    })
  }

  @action
  selectVisibleAllProducts = () => {
    transaction(() => {
      this.filteredProductsHierarchy?.forEach(category => {
        this.selectMultipleProducts(category?.activeProducts)
      })
    })
  }

  @action
  deselectAllProducts = () => {
    this.resetBulkActionSelectedProducts()
  }

  @action
  resetAllSelectionData = () => {
    this.bulkActionSelectedProducts = new ObservableMap()
    this.allProductsData = {}
    this.allProductsHierarchy = []
    this.filteredProductsHierarchy = []
    this.openClearSelelctionWarningDilaog = false
    this.clearSelectionCallBack = null
  }
}
